import { CURRENT_ACTIVATION_FEE } from "./membershipConfig";

export const MEMBERSHIP_VOUCHER_FACE_VALUE = CURRENT_ACTIVATION_FEE;
export const MEMBERSHIP_VOUCHER_ADMIN_FEE_RATE = 0.1;

export function getMembershipVoucherPointsCost(
  faceValue = MEMBERSHIP_VOUCHER_FACE_VALUE
) {
  const adminFee =
    Math.round(faceValue * MEMBERSHIP_VOUCHER_ADMIN_FEE_RATE * 100) / 100;
  const totalPoints =
    Math.round((faceValue + adminFee) * 100) / 100;
  return { faceValue, adminFee, totalPoints };
}
